import React from 'react';
import Select from 'react-select';

export class DateSelect extends React.PureComponent {
  static defaultProps = {
    options: [],
    onChange: () => alert('onChange not defined'),
    value: null,
  };

  render() {
    const { options, onChange, value } = this.props;
    return (
      <div className='flex flex-col text-sm'>
        <div className='text-sm mb-2 font-medium'>By date</div>
        <Select
          id='date'
          className='text-xs font-light w-full'
          placeholder='Select date range'
          options={options}
          onChange={onChange}
          value={value}
        />
      </div>
    );
  }
}

export default DateSelect;
